export default "__VITE_ASSET__BHhqXQvh__"